import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_MY_CERTIFICATE_URL } from "../../network/apis/apiPath";
import { getLocalStoreString } from "../../utils/Helper";
import { GET_MY_CERTIFICATE_DATA } from "../type";
import { saveMyCertificateRequestData } from "./myCertificateConfigSlice";

function* getMyCertificateConfigDataWorker(action) {
    const EmployeeID = getLocalStoreString('EmployeeId');
    const BearerToken = localStorage.getItem("BearerToken");
    const TenantId = getLocalStoreString("CompanyID");
    const Headers = {
        Authorization: `Bearer ${BearerToken}`,
        Accept: 'application/json',
        EmployeeID: EmployeeID,
        "Accrue-Client": "web-app",
        "OS": 'android',
        "App-Ver": 40,
    };
    try {
        const response = (yield call(axios.get, `${GET_MY_CERTIFICATE_URL}/${0}/${10}`, { headers: { ...Headers, "Tenant-Id": TenantId } }));
        if (response) {
            yield put(saveMyCertificateRequestData(response?.data?.Data?.Records))
        }

    } catch (error) {
        console.log(error);
    }
}








export function* myCertificateConfigWatcher() {
    yield takeLatest(GET_MY_CERTIFICATE_DATA, getMyCertificateConfigDataWorker);
}